export { LEGACY_IDV_CONTAINER_ID as LAYOUT_CONTAINER_ID } from '@onefootprint/idv2';
export const LAYOUT_HEADER_ID = 'layout-header';
export const FOOTPRINT_FOOTER_ID = 'footprint-footer';
